import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import "@progress/kendo-theme-material/dist/all.css";
import CaseNoComponent from "../components/caseno";
import FormattedDateComponent from "../components/submittedby";
import DescriptionComponent from "../components/description";
import dropdownFilterCell from "../components/filter";

import { GridWrapper } from "../../../styles/general";
import LockComponent from "../components/lock";
import { caseFormTypeLabels, UserRoles } from "src/constants/api";
import DropdownFilterBooleanCell from "../components/filter-boolean";

import "./index.css";
import { createContext } from "react";

export let GridFilterResetContext = createContext(false);

class KendoGrid extends React.Component<any, any> {
  public state: any = {
    gridData: [],
    result: [],
    dataState: {
      skip: 0,
      take: 100,
      total: 0,
      pageSize: 10,
      pageable: {
        // buttonCount: 5,
        // info: true,
        // type: "numeric",
        pageSizes: [100, 200, 300],
        // previousNext: true
      },
      filter: {
        logic: "and",
        filters: [],
      },
      sort: [],
      group: [],
      // group: [{ field: "status" }, { field: "country" }]
    },
    windowHeight: 300,
    caseType: ["Complaint & Claim", "Claim", "Complaint"],
    complaintStatus: ["Open", "Closed"],
    isUserRequestor: false,
    isGridFilterReset: this.props.isGridFilterReset
  };

  private CCCaseNo = (props: any) => (
    <CaseNoComponent selectCase={this.props.selectCase} {...props} />
  );
  private CCSubmitted = (props: any) => <FormattedDateComponent {...props} />;
  private CCModified = (props: any) => <FormattedDateComponent {...props} />;
  private CCDescription = (props: any) => <DescriptionComponent {...props} />;
  private CCLock = (props: any) => <LockComponent {...props} />;
  private IssueType: any;
  private defaultTextIssueType: string = "Select Issue Type";
  private RequestType: any
  private defaultTextRequestType: any = { text: "Select Type" };
  private CaseType: any;
  private defaultTextCaseType: string = "Select Case Type";
  private ComplaintStatus: any;
  private defaultTextComplaintStatus: string = "Select Complaint Status";
  private ClaimStatus: any;
  private defaultTextClaimStatus: string = "Select Claim Status";
  private ClaimType: any;
  private defaultTextClaimType: string = "Select Claim Type";


  constructor(props: any) {
    super(props);

    this.IssueType = dropdownFilterCell(
      props.issueTypeFilter,
      this.defaultTextIssueType
    );
    this.RequestType = DropdownFilterBooleanCell(
      this.props.requestTypeFilter,
      this.defaultTextRequestType,
      {
        textField: "text",
        dataItemKey: "value",
      },
      {
        updateGridFilterResetState: this.props.updateGridFilterResetState,
      }
    );

    this.CaseType = dropdownFilterCell(
      this.state.caseType,
      this.defaultTextCaseType

    );
    this.ComplaintStatus = dropdownFilterCell(
      this.state.complaintStatus,
      this.defaultTextComplaintStatus
    );
    this.ClaimStatus = dropdownFilterCell(
      props.claimStatusFilter,
      this.defaultTextClaimStatus
    );
    this.ClaimType = dropdownFilterCell(
      props.claimTypeFilter,
      this.defaultTextClaimType
    );
  }

  public componentDidMount() {
    const { gridData, currentUser } = this.props;

    // Check if a user is a Requestor or not.
    const isUserRequestor = currentUser.roleId === UserRoles.UNICEF;

    this.handleResize({});
    window.addEventListener("resize", this.handleResize);
    if (gridData.length) {
      const gridData = JSON.parse(JSON.stringify(this.props.gridData));
      const newGridData = gridData.map((dataItem: any) =>
        Object.assign({ selected: false }, dataItem)
      );

      this.setState({
        gridData: newGridData,
        isUserRequestor,
      });
    }
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    if (this.props.isGridFilterReset !== this.state.isGridFilterReset) {
      this.setState({ isGridFilterReset: this.props.isGridFilterReset });
    }
    // if (prevProps.gridData !== this.props.gridData) {
    //   const gridData = JSON.parse(JSON.stringify(this.props.gridData));
    //   const newGridData = gridData.map((dataItem: any) =>
    //     Object.assign({ selected: false }, dataItem)
    //   );
    //   this.setState({
    //     gridData: newGridData
    //   });
    // }
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  public render() {
    return <GridWrapper>{this.renderGrid()}</GridWrapper>;
  }

  private renderGrid = () => {
    const { dataState, gridData, windowHeight, isUserRequestor } = this.state;
    const { showFilter } = this.props;
    return (
      <GridFilterResetContext.Provider value={this.state.isGridFilterReset}>
        <Grid
          style={{ height: windowHeight, marginTop: "-15px" }}
          data={process(gridData, dataState)}
          pageable={{ pageSizes: [100, 200, 300] }}
          filterable={showFilter}
          sortable={true}
          groupable={true}
          onDataStateChange={this.dataStateChange}
          {...dataState}
          onExpandChange={this.expandChange}
          expandField="expanded"
          selectedField="selected"
          onSelectionChange={this.selectionChange}
          onHeaderSelectionChange={this.headerSelectionChange}
        // rowRender={this.rowRender}
        >
          <Column
            field="selected"
            width="50px"
            filterable={false}
            sortable={false}
            headerSelectionValue={
              gridData.findIndex(
                (dataItem: any) => dataItem.selected === false
              ) === -1
            }
          />
          <Column field="" title="" width="50px" cell={this.CCLock} />
          <Column
            field="caseNo"
            title="Case No"
            width="130px"
            cell={this.CCCaseNo}
          />

          <Column
            field="descriptionOfTheIssue"
            title="Description"
            width="400px"
            cell={this.CCDescription}
          />

          <Column
            field="caseFormType"
            title="Type"
            width="200px"
            filter="text"
            filterCell={this.RequestType}
            cell={({ dataItem, field }) => <td>{field && (caseFormTypeLabels[dataItem[field]] ?? dataItem[field])}</td>}
          />

          <Column
            field="issueType"
            title="Issue type"
            width={showFilter ? "185px" : "150px"}
            filterCell={this.IssueType}
          />
          <Column field="category" title="Category" width="175px" />
          <Column field="poNo" title="PO No." width="150px" />
          <Column field="soldToParty" title="Sold to Party" width="165px" />

          <Column field="countriesAffected" title="Country" width="200px" />
          <Column
            field="centreToHandleComplaint"
            title="Centre to Handle Complaint"
            width="185px"
          />

          <Column
            field="caseType"
            title="Case type"
            width={showFilter ? "185px" : "150px"}
            filterCell={this.CaseType}
          />
          <Column
            field="complaintStatus"
            title="Complaint status"
            width={showFilter ? "225px" : "150px"}
            filterCell={this.ComplaintStatus}
          />
          <Column
            field="claimStatus"
            title="Claim status"
            width={showFilter ? "195px" : "150px"}
            filterCell={this.ClaimStatus}
          />
          {!isUserRequestor ? (
            <Column
              field="claimType"
              title="Claim type"
              width={showFilter ? "185px" : "150px"}
              filterCell={this.ClaimType}
            />
          ) : null}
          {!isUserRequestor ? (
            <Column
              field="insurancePolicyYear"
              title="Insurance policy year"
              width={showFilter ? "185px" : "150px"}
            />
          ) : null}
          {!isUserRequestor ? (
            <Column
              field="legalComments"
              title="Legal comments"
              width={showFilter ? "185px" : "150px"}
            />
          ) : null}

          <Column
            field="internalComments"
            title="Internal comments"
            width={showFilter ? "185px" : "150px"}
          />
          <Column
            field="totalValueOfLoss"
            title="Total value of loss"
            width={showFilter ? "185px" : "150px"}
          />
          <Column
            field="freightForwarderName"
            title="Freight forwarder name"
            width={showFilter ? "185px" : "165px"}
          />
          {!isUserRequestor ? (
            <Column
              field="brokerReference"
              title="Broker reference"
              width={showFilter ? "185px" : "150px"}
            />
          ) : null}

          <Column
            field="settlementAgreed"
            title="Settlement agreed"
            width={showFilter ? "185px" : "150px"}
          />
          <Column
            field="sdSettlementDocumentNo"
            title="SD Settlement doc No"
            width={showFilter ? "185px" : "150px"}
          />
          {!isUserRequestor ? (
            <Column
              field="amountOfRecoveryObtained"
              title="Amt of recovery obtained"
              width="185px"
            />
          ) : null}

          <Column
            field="validated"
            title="Validated"
            width={showFilter ? "185px" : "150px"}
          />
          <Column
            field="correctionIdentified"
            title="Correction(s) identified"
            width="185px"
          />
          <Column
            field="correctionCompleted"
            title="Correction(s) completed"
            width="185px"
          />
          <Column
            field="correctiveActionIdentified"
            title="Corrective action(s) identified"
            width="200px"
          />
          <Column
            field="correctiveActionCompleted"
            title="Corrective action(s) completed"
            width="200px"
          />
          <Column field="createdBy" title="Created By" width="200px" />
          <Column
            field="created"
            title="Created On"
            width="180px"
            cell={this.CCSubmitted}
          />
          <Column field="modifiedBy" title="Modified By" width="150px" />
          <Column
            field="modified"
            title="Modified On"
            width="180px"
            cell={this.CCModified}
          />
        </Grid>
      </GridFilterResetContext.Provider>
    );
  };

  private hasValue(value: any) {
    return value && value.value !== this.defaultTextRequestType;
  }

  private handleChange = (event: any) => {
    if (event.target) {
      const hasValue = this.hasValue(event.target.value);
      event.target.props.onChange({
        value: hasValue ? event.target.value.value : "",
        operator: hasValue ? "eq" : "",
        syntheticEvent: event.syntheticEvent
      });
    }
  }

  private handleResize = (event: any) => {
    const windowHeight = window.innerHeight - 170;
    if (windowHeight > 300) {
      this.setState({
        windowHeight,
      });
    }
  };

  private dataStateChange = (event: any) => {
    this.setState({
      dataState: event.data,
    });
  };

  private expandChange = (event: any) => {
    event.dataItem[event.target.props.expandField] = event.value;
    event.target.setState({});
  };

  private selectionChange = (event: any) => {
    event.dataItem.selected = !event.dataItem.selected;
    this.forceUpdate();
  };

  private headerSelectionChange = (event: any) => {
    const { gridData } = this.state;
    const checked = event.syntheticEvent.target.checked;
    gridData.forEach((item: any) => (item.selected = checked));

    this.forceUpdate();
  };

  // @ts-ignore
  private resetFilter = () => {
    const newData = {
      ...this.state.dataState,
      filter: {
        logic: "and",
        filters: [],
      },
    };
    this.setState({
      dataState: newData,
    });
  };
}

export default KendoGrid;
